// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { ChartData } from '@coa/app/shared/simple-line-chart/components/model/chart-data';
import { DateRangeFilter } from '@coa/app/shared/filters/select-date-range/models/date-range-filter';
import { FeatureToggle } from '@coa/app/shared/feature-toggle/models/feature.toggle';
import { Observable } from 'rxjs';
import { FeatureToggleService } from '@coa/app/shared/feature-toggle/services/feature-toggle.service';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

@Component({
  selector: 'coa-list-element',
  templateUrl: './list-element.component.html',
  styleUrls: ['./list-element.component.scss'],
})
export class ListElementComponent implements OnChanges {
  @Input() clientId;

  @Input() selectable: boolean;
  @Input() selected;

  @Input() number: number;
  @Input() name: string;
  @Input() subName: string;
  @Input() label: string;
  @Input() totalLabel: string;
  @Input() totalValue: number;
  @Input() totalTooltip: string = marker('Traffic index is a ranking of a relationship between a location with the highest and lowest foot traffic in a chosen period.');
  @Input() chartLabel: DateRangeFilter;
  @Input() chartValue: any[];
  @Input() percentageChangeLabel: string;
  @Input() percentageChangeValue: number;
  @Input() percentage: { label: string, value: number };
  @Input() small = false;

  @Output() selectionUpdated = new EventEmitter();

  paymentsEnabledToggle$: Observable<boolean>;

  constructor(
    private featureToggleService: FeatureToggleService,
  ) {
  }

  ngOnChanges(): void {
    if (this.clientId) {
      this.paymentsEnabledToggle$ = this.featureToggleService.isFeatureAdded(FeatureToggle.PAYMENT_EVENTS_ENABLED, this.clientId);
    }
  }

  toggle() {
    this.selectionUpdated.emit(!this.selected);
  }
}
